import React, {Component} from "react";
import "./maintenance-table-mobile.css";
import {connect} from "react-redux";
import Utility from "../maintenance-table/utility";

class StudentAssignmentMaintenanceTableMobile extends Component {
    constructor(props) {
        super(props);
        this.emptyMessage = props.emptyMessage;
        this.columns = props.columns;
        this.subCol = props.columns.filter((col)=> {
            return col.name === 'subjects'
        })[0];
    }

    getRecordIconClass(record) {
        if (record && record.assignmentType) {
            let assignType = record.assignmentType ? record.assignmentType.toLowerCase() : 'learning';
            if (assignType === 'course') {

                return 'booksRow';
            } else if (assignType === 'activity') {
                let type = record.activityType ? record.activityType.toLowerCase() : '';

                switch (type) {
                    case 'url':
                    case 'pdf':
                        return 'learningType';
                    case 'question':
                    case 'questions':
                        return 'questionType';
                    case 'flashcard':
                    case 'flashcards':
                        return 'flashcardType';
                }
            }
        }
        return 'learningType';
    }

    render() {
        let viewCourseMobile = this.props.viewCourseMobile;
        let rows = [];
        for (let i = 0; i < this.props.items.length; i++) {
            let record = this.props.items[i];
            let name = record['assignmentName'] ? Utility.ucFirst(record['assignmentName']) : '';
            let progress = record['progress'] ? parseFloat(record['progress']).toFixed(0) + '% Complete' : '';
            let actClass = this.getRecordIconClass(record);
            //let subject = record['assignmentType'] && record['assignmentType'].toLowerCase() === 'activity' ? record['activitySubject'] : '';

            let dueDate = new Date(parseFloat(record.dueDate));
            let day = dueDate.getUTCDate();
            let month = dueDate.getUTCMonth()+1;
            let year = dueDate.getUTCFullYear();
            let colorClass = dueDate < new Date() ? 'maincolorng' : 'maincolblu';

            let parentId = record['assignmentID'];
            let row = (<div key={parentId} className={"listviewblockBox " + actClass} id={parentId} onClick={()=>{this.props.onRowClick(record);}}>
                    <div className="col-xs-2"><span className="typeIcon"/></div>
                    <div className="col-xs-5">
                          <span className="contentType ">
                              <h4>{name}

                                  {record.activities && record.activities.length > 0 &&
                                  <span className="subRowToggle1" onClick={(evt)=> {

                                      let parentRowId = evt.target.parentElement.parentElement.parentElement.parentElement.id;
                                      let subRows = [...document.querySelectorAll('[id*="' + parentRowId + '-child"]')];
                                      if (evt.target.getAttribute('class').trim().toLowerCase() === 'subRowToggle1'.toLowerCase()) {
                                          for (let j = 0; j < subRows.length; j++) {
                                              let subRow = subRows[j];
                                              subRow.style.display = 'block';
                                          }
                                          evt.target.setAttribute('class', 'subRowToggle1 minus');
                                      } else {
                                          for (let j = 0; j < subRows.length; j++) {
                                              let subRow = subRows[j];
                                              subRow.style.display = 'none';
                                          }
                                          evt.target.setAttribute('class', 'subRowToggle1');
                                      }
                                  }}/>}

                            </h4>
                            <p />
                            <div className="maincolblu">{progress}</div>
                            <p />
                            <p><strong style={{fontWeight: 'bold'}}>Status </strong>
                                <strong>{record['assignmentStatus']}</strong>
                            </p>
                              {/*<p><strong style={{fontWeight: 'bold'}}>Subject </strong>*/}
                              {/*<strong>{subject}</strong>*/}
                              {/*</p>*/}
                          </span>
                    </div>
                    <div className="col-xs-5 text-right">
                            <span className="contentType ">
                                <p>Due Date: </p>
                                <div className={colorClass} style={{float:'right'}}>{month + "/" + day + "/" + year}</div>
                                <p/>
                            </span>
                    </div>
                </div>);
            rows.push(row);
            let count = 0;
            if (record.activities && record.activities.length > 0) {
                record.activities.forEach(act => {
                    let cClass = 'learningType';
                    if (act.activityType) {
                        switch (act.activityType.toLowerCase()) {
                            case 'url':
                            case 'pdf':
                                cClass = 'learningType';
                                break;
                            case 'question':
                            case 'questions':
                                cClass = 'questionType';
                                break;
                            case 'flashcard':
                            case 'flashcards':
                                cClass = 'flashcardType';
                                break;
                        }
                    }

                    let childRow = (<div key={parentId + '-child-' + count} className={"listviewblockBox " + cClass + " posRel"}
                                  id={parentId + '-child-' + count} style={{display: 'none', background: '#f1faf3'}}>
                            <div className="col-xs-2">
                                <span className="typeIcon"/>
                            </div>
                            <div className="col-xs-6">
                                        <span className="contentType ">
                                            <h4>{act.activityName}</h4>
                                            <p>{act.activityProgress} Complete</p>
                                            <p><strong style={{fontWeight: 'bold'}}>Type </strong>
                                                <strong>{act.activityType}</strong>
                                            </p>
                                        </span>
                            </div>
                            <div className="col-xs-4 text-right">
                                        <span className="contentType ">
                                            <p>Due Date: </p>
                                            <div className={colorClass} style={{float:'right'}}>{month + "/" + day + "/" + year}</div>
                                            <p/>
                                        </span>
                            </div>
                        </div>);
                    rows.push(childRow);
                    count++;
                });
            }
        }


        let records = <div className=" mobileListView hidden-lg hidden-tab hidden-md" key={'maintenance-table-mobile'}>
            {rows}
            {this.props.items.length === 0 ? <div className="listviewblockBox emptyMessage">
                {this.props.emptyMessage}
            </div> : ''}
        </div>;
        return (records);
    }
}

function mapStateToProps(state = {}) {
    return {...state};
}
export default connect(mapStateToProps)(StudentAssignmentMaintenanceTableMobile);
